import React, { useEffect, useState } from "react";
import { Col, Container, FloatingLabel, Form, Row } from "react-bootstrap";
import LoadingBtn from '../../components/shared/LoadingBtn';
import SwitchAnlageCard from "../../components/anlage/SwitchAnlageCard";
import PlaceholderCard from "../../components/anlage/PlaceholderCard";
import PrivateApi from "../../services/PrivateApiService";
import SelectedAnlagenList from "../../components/anlage/SelectedAnlagenList";
import ErrorCard from "../../components/shared/ErrorCard";
import { useAuthState } from '../../context/AuthContext';

const LeerstandPage = () => {

    const API = new PrivateApi();
    const qr = localStorage.getItem("qr") ?? null;

    const [anlagen, setAnlagen] = useState([]);
    const [top, setTop] = useState();
    const [selectedAnlagen, setSelectedAnlagen] = useState([]);
    const [noAnlagen, setNoAnlagen] = useState(false);
    const [chagedAnlagen, setChangedAnlagen] = useState([]);
    const [apiError, setApiError] = useState("");
    const [apiErrorStatus, setApiErrorStatus] = useState("");

    const {user} = useAuthState();

    let dt = new Date();
    dt.setMonth(dt.getMonth() - 3);
    const min_date = dt.toISOString().split("T")[0];
    dt = new Date();
    dt.setMonth(dt.getMonth() + 3);
    const max_date = dt.toISOString().split("T")[0];
    dt = new Date();
    let now = dt.toISOString().split("T")[0];
    const [fromDate, setFromDate] = useState(now);
    const [isLoading, setIsLoading] = useState(false);



    const anlagenApiCall = () => {
        setAnlagen([]);
        if (qr !== null) {
            API.hw_TopAnlagen(qr)
                .then((res) => {
                    let data = res.data;
                    setTop(data.top);
                    if (data.top.x_hausverwaltung_id[0] !== user.id) {
                        return setApiError("Sie sind nicht Hausverwaltung von diese Gebäude")
                    }
                    setAnlagen(data.anlagen);
                })
                .catch((er) => {
                    if (er.code === 'ERR_NETWORK') {
                        setApiErrorStatus('ebs-001');
                        setApiError("Es besteht keine Verbindung zum Server, versuchen Sie später noch einmal.");
                    } else {
                        setApiError(er.response.data.detail);
                        console.log("displayed");
                    }
                    setIsLoading(false);
            });
        } else {
            setApiError("Kein QR-Code gefunden.")
        }
    };


    useEffect(() => {
        anlagenApiCall();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    const submitHandler = (e) => {
        setApiError("");
        e.preventDefault();
        setIsLoading(true)
        let anlagen_data = { selectedAnlagen, date: fromDate }
        API.hw_AnlagenSetLeerstand(anlagen_data)
            .then((res) => {
                let data = res.data;
                setChangedAnlagen(data);
                anlagenApiCall();
                setIsLoading(false);
                setSelectedAnlagen([]);
            })
            .catch((err) => {
                if (err.code === "ERR_NETWORK") {
                    setApiErrorStatus("ebs-001");
                    setApiError("Es besteht keine Verbindung zum Server, versuchen Sie später noch einmal.")
                } else {
                    setApiError(err.response.data.detail);
                }
                anlagenApiCall();
                setIsLoading(false);
                setSelectedAnlagen([]);
            })
    };


    return (
        <Container>
            {apiError !== ""? 
                <ErrorCard error={apiError} />
            :null}

            {noAnlagen ?
                <Row>
                    <Col>
                        <h1>Sie sind keine Hausverwaltung von diesem Top</h1>
                    </Col>
                </Row>
                :
                <div>
                    <Row className="mb-5">
                        <Col>
                            <h4>Leerstandsmanagement</h4>
                            <h1>
                                {top? top.x_gebaeude_address_street + " / " + top.x_topnummer: null}
                            </h1>
                        </Col>
                    </Row>

                    <h4>Verfügbare Anlagen</h4>
                    <div>
                        {anlagen && anlagen.length > 0 ?
                            <Row className="justify-content-center">
                                {anlagen.length > 1 ? anlagen.map((anlage) => (
                                    <SwitchAnlageCard key={anlage.id} top={top} anlage={anlage} selected={selectedAnlagen} setSelected={setSelectedAnlagen} />
                                ))
                                    : <SwitchAnlageCard key={anlagen[0].id} top={top} anlage={anlagen[0]} selected={selectedAnlagen} setSelected={setSelectedAnlagen} />
                                }
                            </Row>
                            :
                            <Row className="justify-content-center">
                                <PlaceholderCard />
                            </Row>
                        }
                    </div>
                    <Row className="mt-5 mb-3 justify-content-center">
                        <Col className="mt-3" xs="12" xl="8" hidden={selectedAnlagen.length === 0}>
                            <h3>{selectedAnlagen.length > 1 ? "Aktionen" : "Aktion"}</h3>
                        </Col>
                        <Col className="mt-3 " xs="12" xl="8" hidden={selectedAnlagen.length === 0}>
                            <b>{selectedAnlagen.length > 1 ? "Anlagen" : "Anlage"}</b>
                            {selectedAnlagen.length >= 1 ? <SelectedAnlagenList top={top} selectedAnlagen={selectedAnlagen} anlagen={anlagen}/> :null}
                        </Col>
                        <Col className="mt-5" xs="12" xl="5" hidden={selectedAnlagen.length === 0}>
                            <p>Datum für An-/Abmeldung wählen</p>
                            <Form onSubmit={e => submitHandler(e)}>
                                <FloatingLabel label="Ab Datum">
                                    <Form.Control
                                        type="date"
                                        placeholder="Ab Datum"
                                        value={fromDate}
                                        onChange={e => setFromDate(e.target.value)}
                                        min={min_date}
                                        max={max_date}
                                    />
                                </FloatingLabel>
                                <Col className="mt-5 mb-5">
                                    <LoadingBtn
                                        type="submit"
                                        text={selectedAnlagen.length >= 2 ? "Aktionen durchführen" : "Aktion durchführen"}
                                        isLoading={isLoading}
                                    />
                                </Col>
                            </Form>
                        </Col>
                    </Row>
                </div>
            }
        </Container>
    )
}

export default LeerstandPage;